import React from "react";
import {UserEmailAlertsCenter} from "./UserEmailAlertsCenter";
import {UserContentBase} from "./UserContentBase";


export class UserAlertsContent extends UserContentBase {
    renderModuleMarketingAlerts() {
        if(this.state.canUseModuleMarketingAlerts)
            return (<UserEmailAlertsCenter userId={this.props.userId} />);
    }

    render() {
        return (
            <section className="section-content">
                {this.renderHeaderAndTabs("first")}
                <div className="section-body h-items">
                    {this.renderModuleMarketingAlerts()}
                </div>
            </section>
        )
    }
}
